/**
 * TBM 교육 담당자 링크 **재발송**(F-27, 2026-09-11) — COMPOSED 상세의 「교육 링크 재전송」이 쓴다.
 *
 * 같은 엔드포인트(`POST /reports/tbm/:id/resend`)를 구 TBM 상세의 `resendTBMDistribution`(lib/tbm)과
 * 공유하되 **토큰 id를 넘기지 않는다** — 사용자 결정 「같은 담당자에게 재전송만」이라 고를 것이
 * 없고, 서버가 그 문서의 최신 활성 direct 토큰을 해소한다(`TBMService.resendToEducator`).
 * 재발급이 아니라 같은 링크의 재발송이다(만료됐으면 서버가 만료만 연장한다).
 *
 * ## 왜 `lib/tbm.ts`에 두지 않나
 * `lib/tbm`은 spec 12곳이 `vi.mock` 팩토리로 통째 대체하는 모듈이다 — 거기 새 export를 더하면
 * 그 팩토리에 없는 이름을 import하는 순간 관련 없는 기존 spec이 무더기로 죽는다
 * (`feedback-pure-predicate-must-not-live-in-a-vi-mocked-module`). 흐름 레지스트리
 * (`pages/reports/postSubmitFlows`)가 이 함수를 import하므로 mock 대상 밖에 둔다.
 */
import api, { type ApiResponse } from './api';

export type TbmEducatorResendChannel = 'sms' | 'email';

export interface TbmEducatorResendResult {
  success: boolean;
  /** 실제로 보낸 담당자 이름(토큰 스냅샷) — 성공 토스트가 인용한다. */
  contactName: string;
}

export async function resendTbmEducatorLink(
  reportId: string,
  companyId: string,
  channels: TbmEducatorResendChannel[],
): Promise<TbmEducatorResendResult> {
  const response = await api.post<ApiResponse<TbmEducatorResendResult>>(
    `/reports/tbm/${reportId}/resend?companyId=${companyId}`,
    { channels },
  );
  return response.data.data!;
}
